import { render, staticRenderFns } from "./placeholder.vue?vue&type=template&id=1ffe5a0b&"
import script from "./placeholder.vue?vue&type=script&lang=js&"
export * from "./placeholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports